import * as types from "./types";

/**
 *
 * Store/Reset/Remove data dynamically based on .
 * @param {Object} data - API response on success/error/loading
 * @param {String} type - type for sucess/error/loading
 */

export const onContentRepoListSuccess = (
  payload = {},
  type = types.SUCCESS_CONTENT_REPO_LIST
) => {
  return {
    type,
    payload
  };
};

export const isContentRepoListLoading = (
  payload = {},
  type = types.LOADING_CONTENT_REPO_LIST
) => {
  return {
    type,
    payload
  };
};
